
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","version":"1.0","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('circle',{attrs:{"cx":"16","cy":"64","r":"16","fill":"#036"}}),_c('circle',{attrs:{"cx":"16","cy":"64","r":"14.344","fill":"#036","transform":"rotate(45 64 64)"}}),_c('circle',{attrs:{"cx":"16","cy":"64","r":"12.531","fill":"#036","transform":"rotate(90 64 64)"}}),_c('circle',{attrs:{"cx":"16","cy":"64","r":"10.75","fill":"#036","transform":"rotate(135 64 64)"}}),_c('circle',{attrs:{"cx":"16","cy":"64","r":"10.063","fill":"#036","transform":"rotate(180 64 64)"}}),_c('circle',{attrs:{"cx":"16","cy":"64","r":"8.063","fill":"#036","transform":"rotate(225 64 64)"}}),_c('circle',{attrs:{"cx":"16","cy":"64","r":"6.438","fill":"#036","transform":"rotate(270 64 64)"}}),_c('circle',{attrs:{"cx":"16","cy":"64","r":"5.375","fill":"#036","transform":"rotate(315 64 64)"}}),_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","values":"0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64","calcMode":"discrete","dur":"720ms","repeatCount":"indefinite"}})])])
          )
        }
      }
    